@if (loaded) {
  <div class="content">
    <div class="content-header">
      <div class="title" style="display: flex; align-items: center">
        {{ batch.name }}
        @if (view === 'grid') {
          <mat-checkbox
            (change)="$event ? masterToggleGridList() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            color="primary"
            >Select all
          </mat-checkbox>
        }
      </div>
      <button
        matSuffix
        mat-icon-button
        matTooltip="Page Link"
        matTooltipPosition="above"
      (click)="
        this.clipboardService.copyUrlAndTextToClipboard(this.urlService.getFullUrl(), this.pageLink)
      "
        >
        <mat-icon>link</mat-icon>
      </button>
      <span class="spacer"></span>
      <form>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Search</mat-label>
          <input
            [formControl]="searchForm"
            matInput
            type="text"
            (keyup)="applyFilter($event)"
            placeholder="Filter"
            />
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </form>
      <div class="view-box">
        <mat-button-toggle-group
          [(ngModel)]="view"
          name="view"
          aria-label="View"
          (change)="onViewChanged()"
          hideSingleSelectionIndicator="true"
          >
          <mat-button-toggle value="grid">
            <mat-icon>grid_view</mat-icon>
          </mat-button-toggle>
          <mat-button-toggle value="list">
            <mat-icon>view_list</mat-icon>
          </mat-button-toggle>
          @if (authService.hasPermission(Permission.ShootAssetsRead)) {
            <mat-button-toggle value="qc-production">
              <mat-icon>camera_alt</mat-icon>
            </mat-button-toggle>
          }
          @if (authService.hasPermission(Permission.PostAssetsRead)) {
            <mat-button-toggle value="qc">
              <mat-icon>palette</mat-icon>
            </mat-button-toggle>
          }
        </mat-button-toggle-group>
      </div>
    </div>
    @if (view == 'list') {
      <div>
        <div [hidden]="view !== 'list'">
          <div style="overflow-x: auto">
            <table
              mat-table
              [dataSource]="dataSource"
              class="table"
              matSort
              matSortActive="barcode"
              matSortDirection="desc"
              (matSortChange)="onSortChange($event)"
              >
              <!-- Check Box Column -->
              <ng-container matColumnDef="Select">
                <th mat-header-cell *matHeaderCellDef style="width: 30px">
                  <mat-checkbox
                    (change)="$event ? masterToggle() : null"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()"
                    color="primary"
                    >
                  </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let product">
                  <mat-checkbox
                    (click)="$event.stopPropagation()"
                    (change)="$event ? selection.toggle(product) : null"
                    [checked]="selection.isSelected(product)"
                    color="primary"
                    >
                  </mat-checkbox>
                </td>
              </ng-container>
              <!-- Barcode Column -->
              <ng-container matColumnDef="barcode">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Barcode</th>
                <td mat-cell *matCellDef="let product">{{ product.barcode }}</td>
              </ng-container>
              <!-- Reference Column -->
              <ng-container matColumnDef="reference">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Reference</th>
                <td mat-cell *matCellDef="let product">{{ product.reference }}</td>
              </ng-container>
              <!-- Description Column -->
              <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
                <td mat-cell *matCellDef="let product">
                  {{ product.description }}
                </td>
              </ng-container>
              <!-- Master Suite Column -->
              @if (authService.hasPermission(Permission.ShootAssetsRead)) {
                <ng-container matColumnDef="masterSuiteName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Mastersuite (Variant)</th>
                  <td mat-cell *matCellDef="let product">
                    @if (product.masterSuiteId != null) {
                      <div>
                        {{ product.masterSuiteName }}
                        {{
                        product.settingsVariantName != null ? '(' + product.settingsVariantName + ')' : ''
                        }}
                      </div>
                    }
                  </td>
                </ng-container>
              }
              <!-- Status Column -->
              @if (authService.hasPermission(Permission.ShootAssetsRead)) {
                <ng-container matColumnDef="states">
                  <th mat-header-cell *matHeaderCellDef style="width: 224px">Status</th>
                  <td mat-cell *matCellDef="let product" class="icon-ctn">
                    <div style="display: flex; justify-content: space-between">
                      <mat-icon
                        color="{{ product.states.receivalState }}"
                        matTooltip="Received Quantity {{ product.receivedCount }}"
                        fontIcon="receipt_long"
                      ></mat-icon>
                      <mat-icon
                        color="{{ product.states.masterSuiteState }}"
                  matTooltip="MasterSuite {{
                    product.masterSuiteId != null ? 'Applied' : 'Pending'
                  }}"
                        fontIcon="lightbulb"
                      ></mat-icon>
                      <mat-icon
                        color="{{ product.states.ingestionState }}"
                  matTooltip="{{ product.ingestedTouchCount }}/{{
                    product.expectedTouchCount
                  }} Touches Ingested"
                        fontIcon="dataset"
                      ></mat-icon>
                      <mat-icon
                        color="{{ product.states.productionState }}"
                  matTooltip="{{ product.shotTouchCount }}/{{
                    product.expectedTouchCount
                  }} Touches Shot"
                        fontIcon="camera_alt"
                      ></mat-icon>
                      <mat-icon
                        color="{{ product.states.enhancementState }}"
                  matTooltip="{{ product.postAssetCount }}/{{
                    product.expectedPostAssetCount
                  }} Assets Enhanced"
                        fontIcon="palette"
                      ></mat-icon>
                      <mat-icon
                        mat-icon-button
                        color="{{ product.states.reviewState }}"
                  matTooltip="{{ product.approvedPostAssetCount }}/{{
                    product.expectedPostAssetCount
                  }} Assets Approved"
                        fontIcon="reviews"
                      ></mat-icon>
                      <mat-icon
                        mat-icon-button
                        color="{{ product.states.outputsState }}"
                  matTooltip="{{
                    product.states.outputsState == progressState.INFO
                      ? 'Outputs Pending Release'
                      : product.outdatedRelease
                      ? 'Outdated Release ' +
                        (product.releasedAt | dateAgo : currentConfigDate | async)
                      : product.releasedInCollection
                      ? 'Outputs Released ' +
                        (product.releasedAt | dateAgo : currentConfigDate | async)
                      : product.approvedOutputAssetCount +
                        '/' +
                        product.expectedOutputAssetCount +
                        ' Completed Outputs'
                  }}"
                        fontIcon="filter"
                      ></mat-icon>
                      <mat-icon
                        fontIcon="delivery_dining"
                        color="{{ product.dispatchedCount > 0 ? 'success' : 'pending' }}"
                        matTooltip="Dispatched Quantity {{ product.dispatchedCount }}"
                      ></mat-icon>
                    </div>
                  </td>
                </ng-container>
              }
              @if (!authService.hasPermission(Permission.ShootAssetsRead)) {
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 200px">Status</th>
                  <td mat-cell *matCellDef="let product">
                    <div
                      class="status-text"
                [ngClass]="{
                      complete: product.releasedInCollection && product.approvedOutputAssetCount == product.expectedOutputAssetCount && product.expectedOutputAssetCount > 0,
                    }"
                      >
                      <div class="external-status"></div>
                      {{
                      product.releasedInCollection &&
                      product.approvedOutputAssetCount == product.expectedOutputAssetCount &&
                      product.expectedOutputAssetCount > 0
                      ? 'Complete'
                      : 'Pending'
                      }}
                    </div>
                  </td>
                </ng-container>
              }
              <!-- Actions Column -->
              <ng-container matColumnDef="Actions">
                <th mat-header-cell *matHeaderCellDef style="width: 150px"></th>
                <td mat-cell *matCellDef="let product">
                  <a
                    routerLinkActive="active-link"
                    routerLink="/batches/{{ product.batchId }}/products/{{ product.id }}"
                    ><button
                    mat-icon-button
                    class="mat-elevation-z0"
                    matTooltip="Details"
                    matTooltipPosition="below"
                    color="info"
                    >
                    <mat-icon
                      matBadge="!"
                      matBadgeSize="small"
                      [matBadgeHidden]="product.notes == null || !authService.hasPermission(Permission.ProductsNotes)"
                      >info</mat-icon
                      >
                    </button>
                  </a>
                  @if (authService.hasPermission(Permission.ShootAssetsRead)) {
                    <button
                      [matMenuTriggerFor]="actionsMenu"
                      mat-icon-button
                      matTooltip="More"
                      color="primary"
                      matTooltipPosition="right"
                      class="mat-elevation-z0"
                      >
                      <mat-icon>more_vert</mat-icon>
                    </button>
                  }
                  <mat-menu #actionsMenu="matMenu">
                    <app-edit-action [product]="product" (productUpdated)="onProductUpdated($event, product)"></app-edit-action>
                    <app-receivals-action [product]="product"></app-receivals-action>
                    <app-product-link-action [product]="product"></app-product-link-action>
                    <app-download-wm-action [product]="product"></app-download-wm-action>
                    <app-enhancement-variants-change-action
                      [product]="product"
                      [enhancementVariantIdSelected]="product.masterSuiteEnhancementVariantId"
                      [displayMode]="'menu-item'"
                      (enhancementVariantChanged)="product.masterSuiteEnhancementVariantId = $event"
                    ></app-enhancement-variants-change-action>
                    <app-delete-action [product]="product" (productDeleted)="getListProduct()"></app-delete-action>
                  </mat-menu>
                </td>
              </ng-container>
              <!-- Header row second group -->
              @if (authService.hasPermission(Permission.ShootAssetsRead)) {
                <ng-container matColumnDef="filters-row">
                  <th mat-header-cell *matHeaderCellDef [attr.colspan]="displayedColumns.length">
                    <div style="display: flex; align-items: center">
                      <app-dynamic-chip-set
                        style="width: 100%"
                        [chips]="preDefinedFilters"
                        [loading]="productsSubscription && !productsSubscription.closed"
                        [selectedChipKey]="selectedfilter"
                        (chipSelected)="onPreDefinedFilterChange($event)"
                      ></app-dynamic-chip-set>
                      <span class="spacer"></span>
                      <button
                        mat-icon-button
                        [matMenuTriggerFor]="filtersMenu"
                        matTooltip="Filters"
                        matTooltipPosition="above"
                        color="primary"
                        >
                        <mat-icon>{{ allEmpty(filter) ? 'filter_list_off' : 'filter_list' }}</mat-icon>
                      </button>
                    </div>
                  </th>
                </ng-container>
              }
              <tr
                mat-header-row
            [style]="{
              display: authService.hasPermission(Permission.ShootAssetsRead) ? 'contents' : 'none'
            }"
                *matHeaderRowDef="authService.hasPermission(Permission.ShootAssetsRead) ? ['filters-row'] : []"
              ></tr>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"
                (click)="selectRow($event, row)"
              ></tr>
            </table>
          </div>
          <div class="paginator-row">
            @if (selection.hasValue()) {
              <span class="selected-count">
                {{ selection.selected.length }} selected
              </span>
            }
            <mat-paginator
              [pageSizeOptions]="[10, 20, 50, 100]"
              showFirstLastButtons
              aria-label="Select page of Products"
              [pageIndex]="pageIndex"
              [pageSize]="pageSize"
              (page)="pageNumberChange($event)"
              >
            </mat-paginator>
          </div>
          @if (productsSubscription && !productsSubscription.closed) {
            <mat-progress-bar
              mode="query"
            ></mat-progress-bar>
          }
        </div>
        <div class="content-actions">
          <span class="spacer"></span>
          <app-batch-actions-dropdown
            [products]="products"
            [masterSuites]="masterSuites"
            (actionComplete)="getListProduct()"
            style="margin-bottom: 27px"
          ></app-batch-actions-dropdown>
          <app-product-actions-dropdown
            [selectedProducts]="selection.selected"
            [masterSuites]="masterSuites"
            [organizationId]="currentOrganizationId"
            [batchId]="batch.id!"
            (actionComplete)="getListProduct()"
            style="margin-bottom: 27px"
          ></app-product-actions-dropdown>
        </div>
      </div>
    }
    @if (view == 'grid') {
      <div class="product-grid">
        @if (authService.hasPermission(Permission.ShootAssetsRead)) {
          <div style="display: flex; align-items: center">
            @if (view == 'grid') {
              <app-dynamic-chip-set
                style="width: 100%"
                [chips]="preDefinedFilters"
                [loading]="productsSubscription && !productsSubscription.closed"
                [selectedChipKey]="selectedfilter"
                (chipSelected)="onPreDefinedFilterChange($event)"
              ></app-dynamic-chip-set>
            }
            <span class="spacer"></span>
            <button
              mat-icon-button
              [matMenuTriggerFor]="filtersMenu"
              matTooltip="Filters"
              matTooltipPosition="above"
              color="primary"
              >
              <mat-icon>{{ allEmpty(filter) ? 'filter_list_off' : 'filter_list' }}</mat-icon>
            </button>
          </div>
        }
        <mat-grid-list [cols]="colPerScreen" [rowHeight]="'1:1'" gutterSize="10">
          @for (product of girdList; track product) {
            <mat-grid-tile [colspan]="1">
              <div class="product-grid-item">
                <div class="product-grid-item__label">
                  <div class="text-ellipse">
                    {{ product.barcode || product.reference }}
                  </div>
                  <div
                    class="external-status"
                [ngClass]="{
                  approved:
                    product.approvedPostAssetCount ==
                      product.expectedPostAssetCount &&
                      product.expectedPostAssetCount > 0,
                  active: product.approvedPostAssetCount > 0 && product.approvedPostAssetCount !=
                      product.expectedPostAssetCount && product.rejectedPostAssetCount == 0,
                  rejected: product.rejectedPostAssetCount > 0,
                }"
                  ></div>
                </div>
                <div
                  class="product-grid-item__thumb-img"
                  routerLinkActive="active-link"
                  routerLink="{{ product.id }}"
                  >
                  @if (!!product.thumbnailUri) {
                    <img
                      [src]="getLinkImage(product.thumbnailUri, product) | secure | async"
                      [alt]=""
                      matTooltipPosition="above"
                      (load)="product.loadedImage = true"
                      [hidden]="!product.loadedImage"
                      />
                  } @else {
                    <div class="product-grid-item__no-img">
                      <img
                        [src]="'assets/image-placeholder.jpg'"
                        alt="Image Error"
                        matTooltipPosition="above"
                        />
                    </div>
                  }
                  @if (!!product.thumbnailUri && !product.loadedImage) {
                    <div
                      class="product-grid-item__no-img"
                      >
                      <img
                        [src]="'assets/image-placeholder.jpg'"
                        alt="Image Error"
                        matTooltipPosition="above"
                        />
                    </div>
                  }
                </div>
                <div class="text-ellipse">
                  {{ product.description }}
                </div>
                <div class="action-ctn">
                  <mat-checkbox
                    (click)="$event.stopPropagation()"
                    (change)="$event ? selection.toggle(product) : null"
                    [checked]="selection.isSelected(product)"
                    color="primary"
                  ></mat-checkbox>
                  <div class="spacer"></div>
                  <a routerLinkActive="active-link" routerLink="{{ product.id }}">
                    <button
                      mat-icon-button
                      class="mat-elevation-z0"
                      matTooltip="Details"
                      matTooltipPosition="left"
                      color="info"
                      >
                      @if (product.notes == null) {
                        <mat-icon>info</mat-icon>
                      } @else {
                        <mat-icon matBadge="!" matBadgeSize="small">info</mat-icon>
                      }
                    </button>
                  </a>
                  @if (authService.hasPermission(Permission.ShootAssetsRead)) {
                    <button
                      [matMenuTriggerFor]="actionsMenu"
                      mat-icon-button
                      matTooltip="More"
                      color="primary"
                      matTooltipPosition="right"
                      class="mat-elevation-z0"
                      >
                      <mat-icon>more_vert</mat-icon>
                    </button>
                  }
                  <mat-menu #actionsMenu="matMenu">
                    <app-edit-action [product]="product" (productUpdated)="onProductUpdated($event, product)"></app-edit-action>
                    <app-receivals-action [product]="product"></app-receivals-action>
                    <app-product-link-action [product]="product"></app-product-link-action>
                    <app-download-wm-action [product]="product"></app-download-wm-action>
                    <app-enhancement-variants-change-action
                      [product]="product"
                      [enhancementVariantIdSelected]="product.masterSuiteEnhancementVariantId"
                      [displayMode]="'menu-item'"
                      (enhancementVariantChanged)="product.masterSuiteEnhancementVariantId = $event"
                    ></app-enhancement-variants-change-action>
                    <app-delete-action [product]="product" (productDeleted)="getListProduct()"></app-delete-action>
                  </mat-menu>
                </div>
              </div>
            </mat-grid-tile>
          }
        </mat-grid-list>
      </div>
    }
    @if (view === 'qc-production') {
      <app-products-qc-view
        [batchId]="batch.id!"
        [products]="dataSource.filteredData"
        type="shootAssets"
      ></app-products-qc-view>
    }
    @if (view === 'qc') {
      <app-products-qc-view
        [batchId]="batch.id!"
        [products]="dataSource.filteredData"
        type="postAssets"
      ></app-products-qc-view>
    }
  </div>
}

<mat-menu #filtersMenu="matMenu" (closed)="filterProducts()">
  <div style="width: 350px; padding: 2px 10px !important" (click)="$event.stopPropagation()">
    <div style="display: flex; align-items: center; margin: 4px">
      Status Filters
      <span class="spacer"></span>
      <button mat-button class="action-button" (click)="clearFilters()">Clear</button>
    </div>
    <div class="filter-item">
      <div class="label">Receivals</div>
      <span class="spacer"></span>
      <mat-button-toggle-group
        class="filter-toggle-group"
        [(ngModel)]="filter.receivalState"
        multiple
        hideMultipleSelectionIndicator
        >
        <mat-button-toggle [value]="progressState.PENDING">
          <mat-icon color="pending" matTooltip="Pending" matTooltipPosition="above"
            >receipt_long</mat-icon
            >
          </mat-button-toggle>
          <mat-button-toggle [value]="progressState.ERROR">
            <mat-icon color="error" matTooltip="Poor Condition" matTooltipPosition="above"
              >receipt_long</mat-icon
              >
            </mat-button-toggle>
            <mat-button-toggle [value]="progressState.ACTIVE">
              <mat-icon color="warning" matTooltip="Okay Condition" matTooltipPosition="above"
                >receipt_long</mat-icon
                >
              </mat-button-toggle>
              <mat-button-toggle [value]="progressState.COMPLETE">
                <mat-icon color="success" matTooltip="Good Condition" matTooltipPosition="above"
                  >receipt_long</mat-icon
                  >
                </mat-button-toggle>
              </mat-button-toggle-group>
            </div>

            <div class="filter-item">
              <div class="label">Master Suite</div>
              <span class="spacer"></span>
              <mat-button-toggle-group
                class="filter-toggle-group"
                [(ngModel)]="filter.masterSuiteState"
                multiple
                hideMultipleSelectionIndicator
                >
                <mat-button-toggle [value]="progressState.PENDING">
                  <mat-icon color="pending" matTooltip="Pending" matTooltipPosition="above"
                    >lightbulb</mat-icon
                    >
                  </mat-button-toggle>
                  <mat-button-toggle [value]="progressState.ACTIVE">
                    <mat-icon color="warning" matTooltip="Pending Settings" matTooltipPosition="above"
                      >lightbulb</mat-icon
                      >
                    </mat-button-toggle>
                    <mat-button-toggle [value]="progressState.COMPLETE">
                      <mat-icon color="success" matTooltip="Applied" matTooltipPosition="above"
                        >lightbulb</mat-icon
                        >
                      </mat-button-toggle>
                    </mat-button-toggle-group>
                  </div>

                  <div class="filter-item">
                    <div class="label">Ingestion</div>
                    <span class="spacer"></span>
                    <mat-button-toggle-group
                      class="filter-toggle-group"
                      [(ngModel)]="filter.ingestionState"
                      multiple
                      hideMultipleSelectionIndicator
                      >
                      <mat-button-toggle [value]="progressState.PENDING">
                        <mat-icon color="pending" matTooltip="Pending" matTooltipPosition="above"
                          >dataset</mat-icon
                          >
                        </mat-button-toggle>
                        <mat-button-toggle [value]="progressState.ACTIVE">
                          <mat-icon color="warning" matTooltip="Partially Ingested" matTooltipPosition="above"
                            >dataset</mat-icon
                            >
                          </mat-button-toggle>
                          <mat-button-toggle [value]="progressState.COMPLETE">
                            <mat-icon color="success" matTooltip="Ingested" matTooltipPosition="above"
                              >dataset</mat-icon
                              >
                            </mat-button-toggle>
                          </mat-button-toggle-group>
                        </div>

                        <div class="filter-item">
                          <div class="label">Production</div>
                          <span class="spacer"></span>
                          <mat-button-toggle-group
                            class="filter-toggle-group"
                            [(ngModel)]="filter.productionState"
                            multiple
                            hideMultipleSelectionIndicator
                            >
                            <mat-button-toggle [value]="progressState.PENDING">
                              <mat-icon color="pending" matTooltip="Pending" matTooltipPosition="above"
                                >camera_alt</mat-icon
                                >
                              </mat-button-toggle>
                              <mat-button-toggle [value]="progressState.ACTIVE">
                                <mat-icon color="warning" matTooltip="Partially Shot" matTooltipPosition="above"
                                  >camera_alt</mat-icon
                                  >
                                </mat-button-toggle>
                                <mat-button-toggle [value]="progressState.COMPLETE">
                                  <mat-icon color="success" matTooltip="Shot" matTooltipPosition="above"
                                    >camera_alt</mat-icon
                                    >
                                  </mat-button-toggle>
                                </mat-button-toggle-group>
                              </div>

                              <div class="filter-item">
                                <div class="label">Raw Reviews</div>
                                <span class="spacer"></span>
                                <mat-button-toggle-group
                                  class="filter-toggle-group"
                                  [(ngModel)]="filter.productionReviewState"
                                  multiple
                                  hideMultipleSelectionIndicator
                                  >
                                  <mat-button-toggle [value]="progressState.PENDING">
                                    <mat-icon color="pending" matTooltip="Pending" matTooltipPosition="above"
                                      >camera_enhance</mat-icon
                                      >
                                    </mat-button-toggle>
                                    <mat-button-toggle [value]="progressState.ERROR">
                                      <mat-icon color="error" matTooltip="Rejected" matTooltipPosition="above"
                                        >camera_enhance</mat-icon
                                        >
                                      </mat-button-toggle>
                                      <mat-button-toggle [value]="progressState.ACTIVE">
                                        <mat-icon color="warning" matTooltip="Partially Approved" matTooltipPosition="above"
                                          >camera_enhance</mat-icon
                                          >
                                        </mat-button-toggle>
                                        <mat-button-toggle [value]="progressState.COMPLETE">
                                          <mat-icon color="success" matTooltip="Approved" matTooltipPosition="above"
                                            >camera_enhance</mat-icon
                                            >
                                          </mat-button-toggle>
                                        </mat-button-toggle-group>
                                      </div>

                                      <div class="filter-item">
                                        <div class="label">Enhancement</div>
                                        <span class="spacer"></span>
                                        <mat-button-toggle-group
                                          class="filter-toggle-group"
                                          [(ngModel)]="filter.enhancementState"
                                          multiple
                                          hideMultipleSelectionIndicator
                                          >
                                          <mat-button-toggle [value]="progressState.PENDING">
                                            <mat-icon color="pending" matTooltip="Pending" matTooltipPosition="above"
                                              >palette</mat-icon
                                              >
                                            </mat-button-toggle>
                                            <mat-button-toggle [value]="progressState.ERROR">
                                              <mat-icon color="error" matTooltip="Internally Rejected" matTooltipPosition="above"
                                                >palette</mat-icon
                                                >
                                              </mat-button-toggle>
                                              <mat-button-toggle [value]="progressState.ACTIVE">
                                                <mat-icon color="warning" matTooltip="Partially Enhanced" matTooltipPosition="above"
                                                  >palette</mat-icon
                                                  >
                                                </mat-button-toggle>
                                                <mat-button-toggle [value]="progressState.COMPLETE">
                                                  <mat-icon color="success" matTooltip="Enhanced" matTooltipPosition="above"
                                                    >palette</mat-icon
                                                    >
                                                  </mat-button-toggle>
                                                </mat-button-toggle-group>
                                              </div>

                                              <div class="filter-item">
                                                <div class="label">Reviews</div>
                                                <span class="spacer"></span>
                                                <mat-button-toggle-group
                                                  class="filter-toggle-group"
                                                  [(ngModel)]="filter.reviewState"
                                                  multiple
                                                  hideMultipleSelectionIndicator
                                                  >
                                                  <mat-button-toggle [value]="progressState.PENDING">
                                                    <mat-icon color="pending" matTooltip="Pending" matTooltipPosition="above"
                                                      >reviews</mat-icon
                                                      >
                                                    </mat-button-toggle>
                                                    <mat-button-toggle [value]="progressState.ERROR">
                                                      <mat-icon color="error" matTooltip="Rejected" matTooltipPosition="above"
                                                        >reviews</mat-icon
                                                        >
                                                      </mat-button-toggle>
                                                      <mat-button-toggle [value]="progressState.ACTIVE">
                                                        <mat-icon color="warning" matTooltip="Partially Approved" matTooltipPosition="above"
                                                          >reviews</mat-icon
                                                          >
                                                        </mat-button-toggle>
                                                        <mat-button-toggle [value]="progressState.COMPLETE">
                                                          <mat-icon color="success" matTooltip="Approved" matTooltipPosition="above"
                                                            >reviews</mat-icon
                                                            >
                                                          </mat-button-toggle>
                                                        </mat-button-toggle-group>
                                                      </div>

                                                      <div class="filter-item">
                                                        <div class="label">Outputs</div>
                                                        <span class="spacer"></span>
                                                        <mat-button-toggle-group
                                                          class="filter-toggle-group"
                                                          [(ngModel)]="filter.outputsState"
                                                          multiple
                                                          hideMultipleSelectionIndicator
                                                          >
                                                          <mat-button-toggle [value]="progressState.PENDING">
                                                            <mat-icon color="pending" matTooltip="Pending" matTooltipPosition="above"
                                                              >filter</mat-icon
                                                              >
                                                            </mat-button-toggle>
                                                            <mat-button-toggle [value]="progressState.ERROR">
                                                              <mat-icon color="error" matTooltip="Rejected Assets" matTooltipPosition="above"
                                                                >filter</mat-icon
                                                                >
                                                              </mat-button-toggle>
                                                              <mat-button-toggle [value]="progressState.ACTIVE">
                                                                <mat-icon color="warning" matTooltip="Partial / Outdated" matTooltipPosition="above"
                                                                  >filter</mat-icon
                                                                  >
                                                                </mat-button-toggle>
                                                                <mat-button-toggle [value]="progressState.INFO">
                                                                  <mat-icon color="info" matTooltip="Ready for Release" matTooltipPosition="above"
                                                                    >filter</mat-icon
                                                                    >
                                                                  </mat-button-toggle>
                                                                  <mat-button-toggle [value]="progressState.COMPLETE">
                                                                    <mat-icon color="success" matTooltip="Released" matTooltipPosition="above"
                                                                      >filter</mat-icon
                                                                      >
                                                                    </mat-button-toggle>
                                                                  </mat-button-toggle-group>
                                                                </div>

                                                                <div class="filter-item">
                                                                  <div class="label">Dispatched</div>
                                                                  <span class="spacer"></span>
                                                                  <mat-button-toggle-group
                                                                    class="filter-toggle-group"
                                                                    [(ngModel)]="filter.dispatchState"
                                                                    multiple
                                                                    hideMultipleSelectionIndicator
                                                                    >
                                                                    <mat-button-toggle [value]="progressState.PENDING">
                                                                      <mat-icon color="pending" matTooltip="Pending" matTooltipPosition="above"
                                                                        >delivery_dining</mat-icon
                                                                        >
                                                                      </mat-button-toggle>
                                                                      <mat-button-toggle [value]="progressState.COMPLETE">
                                                                        <mat-icon color="success" matTooltip="Dispatched" matTooltipPosition="above"
                                                                          >delivery_dining</mat-icon
                                                                          >
                                                                        </mat-button-toggle>
                                                                      </mat-button-toggle-group>
                                                                    </div>

                                                                    <div style="display: flex; justify-content: end">
                                                                      <button
                                                                        mat-raised-button
                                                                        color="buttonSuccess"
                                                                        class="action-button"
                                                                        (click)="filterProducts()"
                                                                        >
                                                                        Apply
                                                                      </button>
                                                                    </div>
                                                                  </div>
                                                                </mat-menu>
